import { render, staticRenderFns } from "./Shots.vue?vue&type=template&id=aa08b158&scoped=true&"
import script from "./Shots.vue?vue&type=script&lang=js&"
export * from "./Shots.vue?vue&type=script&lang=js&"
import style0 from "./Shots.vue?vue&type=style&index=0&id=aa08b158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa08b158",
  null
  
)

export default component.exports